import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom'; // Use these instead of useSearchParams
import Navbar8 from '../components/navbar8';
import Footer4 from '../components/footer4';
import Toolkit1 from '../components/toolkit1';
import ResourcesLayout from '../components/ResourcesLayout';
import SASUWI from '../components/sasuwi';
import './resources.css';

const Resources = () => {
  const location = useLocation();
  const history = useHistory();
  
  // Function to get section from URL
  const getSectionFromURL = () => {
    const params = new URLSearchParams(location.search);
    return params.get('section') || 'toolkit';
  };

  const [activeSection, setActiveSection] = useState(getSectionFromURL);

  useEffect(() => {
    // Update URL when activeSection changes
    const params = new URLSearchParams();
    params.set('section', activeSection);
    history.push({ search: params.toString() });
  }, [activeSection, history]);

  const renderContent = () => {
    switch (activeSection) {
      case 'toolkit':
        return <Toolkit1 />;
      case 'sas':
        return <SASUWI />;
      default:
        return <Toolkit1 />;
    }
  };

  return (
    <div className="page-wrapper">
      <Navbar8 />
      <ResourcesLayout 
        activeSection={activeSection} 
        setActiveSection={setActiveSection}
      >
        {renderContent()}
      </ResourcesLayout>
      <Footer4 />
    </div>
  );
};

export default Resources;
